import { DataBlob } from "@royalty/httpclient";
export class ExcelServiceClient {
	public static openExcelFile(data: DataBlob): void {
		const blob = new Blob([data.blob], {
			type:
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
		});
		const link = document.createElement("a");
		link.href = window.URL.createObjectURL(blob);
		link.download = this.parseFileName(data.contentDisposition);
		link.click();
	}

	private static parseFileName(content: string) {
		const arrSplit = content.split(" ");
		let filename = "report";
		if (arrSplit) {
			arrSplit.some(x => {
				if (x.indexOf("filename=") > -1) {
					filename = x.replace("filename=", "");
					filename = filename.replace(";", "");
					return true;
				}
			});
		}
		return filename;
	}
}
